
const digest = '28b57d842dff29f391aacf5c3f77d71ef75f843da264595e11824fff70605803';
const classes = {"wrapper":"_wrapper_yd2zg_1"};
const css = `._wrapper_yd2zg_1 {
  border-radius: 20px;
  position: fixed;
  background: #ffffff;
  bottom: 20px;
  right: 20px;
  padding: 10px 12px;
  box-shadow: 0px 0px 10px -3px rgba(0, 0, 0, 0.75);
  -webkit-box-shadow: 0px 0px 10px -3px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 10px -3px rgba(0, 0, 0, 0.75);
  border: 1px solid #d1d4db;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  